<template>
  <section class="mb-10">
    <h2
      class="text-2xl font-bold mb-4 cursor-pointer text-azul-profundo"
      @click="$emit('go-to-section', title)"
    >
      {{ title }}
    </h2>

    <VitrineProductGrid
      :products="products"
      :placeholder-image="placeholderImage"
      :campaigns-cat="campaignsCat"
      :campaigns-prod="campaignsProd"
      :limit="limit"
      @open="$emit('open', $event)"
    />
  </section>
</template>

<script>
import VitrineProductGrid from "@/components/VitrineProductGrid.vue";

export default {
  name: "VitrineSectionBlock",
  components: { VitrineProductGrid },
  props: {
    title: { type: String, required: true },
    products: { type: Array, default: () => [] },
    placeholderImage: { type: String, required: true },
    campaignsCat: { type: Array, default: () => [] },
    campaignsProd: { type: Array, default: () => [] },
    limit: { type: Number, default: 4 },
  },
  emits: ["open", "go-to-section"],
};
</script>
